/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getUsers } from 'app/shared/reducers/user-management';
import { getEntities as getContactDetails } from 'app/entities/contact-details/contact-details.reducer';
import { Gender } from 'app/shared/model/enumerations/gender.model';
import { BloodGroup } from 'app/shared/model/enumerations/blood-group.model';
import { ParamedicType } from 'app/shared/model/enumerations/paramedic-type.model';
import { createEntity, getEntity, reset, updateEntity } from './paramedic.reducer';

export const ParamedicUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const users = useAppSelector(state => state.userManagement.users);
  const contactDetails = useAppSelector(state => state.contactDetails.entities);
  const paramedicEntity = useAppSelector(state => state.paramedic.entity);
  const loading = useAppSelector(state => state.paramedic.loading);
  const updating = useAppSelector(state => state.paramedic.updating);
  const updateSuccess = useAppSelector(state => state.paramedic.updateSuccess);
  const genderValues = Object.keys(Gender);
  const bloodGroupValues = Object.keys(BloodGroup);
  const paramedicTypeValues = Object.keys(ParamedicType);

  const handleClose = () => {
    navigate(`/paramedic${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUsers({}));
    dispatch(getContactDetails({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.visitCharge !== undefined && typeof values.visitCharge !== 'number') {
      values.visitCharge = Number(values.visitCharge);
    }
    if (values.age !== undefined && typeof values.age !== 'number') {
      values.age = Number(values.age);
    }
    if (values.dateOfBirth !== undefined && typeof values.dateOfBirth !== 'number') {
      values.dateOfBirth = Number(values.dateOfBirth);
    }
    if (values.registrationValidUpto !== undefined && typeof values.registrationValidUpto !== 'number') {
      values.registrationValidUpto = Number(values.registrationValidUpto);
    }

    const entity = {
      ...paramedicEntity,
      ...values,
      user: users.find(it => it.id.toString() === values.user?.toString()),
      contactCode: contactDetails.find(it => it.id.toString() === values.contactCode?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          gender: 'NA',
          bloodGroup: 'O_POS',
          paramedicType: 'REMOTE_PRACTITIONER',
          ...paramedicEntity,
          user: paramedicEntity?.user?.id,
          contactCode: paramedicEntity?.contactCode?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.paramedic.home.createOrEditLabel" data-cy="ParamedicCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.paramedic.home.createOrEditLabel">Create or edit a Paramedic</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="paramedic-id"
                  label={translate('tinyMedicRestApp.paramedic.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.education')}
                id="paramedic-education"
                name="education"
                data-cy="education"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.training')}
                id="paramedic-training"
                name="training"
                data-cy="training"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.experience')}
                id="paramedic-experience"
                name="experience"
                data-cy="experience"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.achievements')}
                id="paramedic-achievements"
                name="achievements"
                data-cy="achievements"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.timestampentry')}
                id="paramedic-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.microSec')}
                id="paramedic-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.lastupdated')}
                id="paramedic-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.active')}
                id="paramedic-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.cursor')}
                id="paramedic-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.name')}
                id="paramedic-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.email')}
                id="paramedic-email"
                name="email"
                data-cy="email"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.visitCharge')}
                id="paramedic-visitCharge"
                name="visitCharge"
                data-cy="visitCharge"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField label={translate('tinyMedicRestApp.paramedic.age')} id="paramedic-age" name="age" data-cy="age" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.gender')}
                id="paramedic-gender"
                name="gender"
                data-cy="gender"
                type="select"
              >
                {genderValues.map(gender => (
                  <option value={gender} key={gender}>
                    {translate(`tinyMedicRestApp.Gender.${gender}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.mobile')}
                id="paramedic-mobile"
                name="mobile"
                data-cy="mobile"
                type="text"
                validate={{
                  maxLength: { value: 30, message: translate('entity.validation.maxlength', { max: 30 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.dateOfBirth')}
                id="paramedic-dateOfBirth"
                name="dateOfBirth"
                data-cy="dateOfBirth"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.bloodGroup')}
                id="paramedic-bloodGroup"
                name="bloodGroup"
                data-cy="bloodGroup"
                type="select"
              >
                {bloodGroupValues.map(bloodGroup => (
                  <option value={bloodGroup} key={bloodGroup}>
                    {translate(`tinyMedicRestApp.BloodGroup.${bloodGroup}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.paramedicType')}
                id="paramedic-paramedicType"
                name="paramedicType"
                data-cy="paramedicType"
                type="select"
              >
                {paramedicTypeValues.map(paramedicType => (
                  <option value={paramedicType} key={paramedicType}>
                    {translate(`tinyMedicRestApp.ParamedicType.${paramedicType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.registrationCode')}
                id="paramedic-registrationCode"
                name="registrationCode"
                data-cy="registrationCode"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.registrationNumber')}
                id="paramedic-registrationNumber"
                name="registrationNumber"
                data-cy="registrationNumber"
                type="text"
                validate={{
                  maxLength: { value: 45, message: translate('entity.validation.maxlength', { max: 45 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.registrationValidUpto')}
                id="paramedic-registrationValidUpto"
                name="registrationValidUpto"
                data-cy="registrationValidUpto"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.knownLanguages')}
                id="paramedic-knownLanguages"
                name="knownLanguages"
                data-cy="knownLanguages"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.qualification')}
                id="paramedic-qualification"
                name="qualification"
                data-cy="qualification"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.paramedic.practicingCity')}
                id="paramedic-practicingCity"
                name="practicingCity"
                data-cy="practicingCity"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                id="paramedic-user"
                name="user"
                data-cy="user"
                label={translate('tinyMedicRestApp.paramedic.user')}
                type="select"
                required
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="paramedic-contactCode"
                name="contactCode"
                data-cy="contactCode"
                label={translate('tinyMedicRestApp.paramedic.contactCode')}
                type="select"
                required
              >
                <option value="" key="0" />
                {contactDetails
                  ? contactDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/paramedic" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ParamedicUpdate;
